import React from 'react'
import Fragment from '../common/fragment'

function FragmentBP(props) {
  return (
    <Fragment pos="pp" {...props}>
      <p>
El Muñeco es un Caballo de Troya y su interior está repleto de abejas, que
invadirán la ciudad y los campos y transfigurarán la Refinería en un gigantesco
panal de metal y niebla. Como los viejos animales de Chernobyl, entre la hierba
crecida de los jardines, el Lobo yacerá junto al Cordero. No será el Paraíso, pero
estaremos contentos, atrapados por una felicidad pasajera. Desde la azotea del
Convento se ven las chimeneas de la Refinería como faros que guían a una
oscuridad más profunda, en estos mares secos y la ciega resistencia de las rocas.
También se escucha el tren y la voz de los predicadores en esa plaza de piedra, en
estos desiertos y sus cobijos.
      </p>
    </Fragment>
  )
}


export default FragmentBP
